import { ORION_ACCOUNT, ORION_CLIENT, ORION_MODEL, ORION_MODEL_AGGREGATE, ORION_PORTFOLIO_GROUP, } from 'IntegrationsApp/ts/constants';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class OrionIntegrationService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getOrionIntegrationStatus() {
        const url = this.urlsService.INTEGRATIONS.ORION_INTEGRATION_STATUS;
        return this.ajaxService.getDataObserveBody(url);
    }
    deactivateOrionIntegration() {
        const url = this.urlsService.INTEGRATIONS.ORION_INTEGRATION_AUTH;
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    getOrionClientSearchResults(searchTerms, page) {
        const urlParams = { searchType: ORION_CLIENT };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ORION_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getOrionAccountSearchResults(searchTerms, page) {
        const urlParams = { searchType: ORION_ACCOUNT };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ORION_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getOrionModelSearchResults(searchTerms, page) {
        const urlParams = { searchType: ORION_MODEL };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ORION_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getOrionPortfolioGroupSearchResults(searchTerms, page) {
        const urlParams = { searchType: ORION_PORTFOLIO_GROUP };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ORION_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getOrionModelAggSearchResults(searchTerms, page) {
        const urlParams = { searchType: ORION_MODEL_AGGREGATE };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ORION_SEARCH, urlParams)}?searchTerms=${searchTerms}&page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    getOrionClientAccounts(clientId, page) {
        const urlParams = { clientId };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ORION_CLIENT_ACCOUNTS, urlParams)}?page=${page}`;
        return this.ajaxService.getDataObserveBody(url);
    }
    importOrionHoldings(importType, postParams) {
        const urlParams = { searchType: importType };
        const url = `${this.urlsService.getUrl(this.urlsService.INTEGRATIONS.ORION_IMPORT_HOLDINGS, urlParams)}`;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
}
OrionIntegrationService.ɵfac = function OrionIntegrationService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || OrionIntegrationService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
OrionIntegrationService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: OrionIntegrationService, factory: OrionIntegrationService.ɵfac, providedIn: 'root' });
